import axios from 'axios';
import type { Lesson } from '@/models/lesson';
import type { Phase } from '@/models/phase';
import type { Topic } from '@/models/topic';
import type { Tag } from '@/models/tag';

class LessonWebservice {
    public load(tradeId: number, topicId: number, exclude_lesson_id: number | null = null) {
        return axios.get<Lesson[]>('/lessons', {
            params: {
                tradeId,
                topicId,
                exclude_lesson_id,
            },
        });
    }

    public loadLessonsByApproved(approved: boolean) {
        return axios.get<Lesson[]>('/lessons/loadLessonsByApproved', {
            params: {
                approved,
            },
        });
    }

    public getById(lessonId: string) {
        return axios.get<Lesson>('/lessons/getById', {
            params: {
                lessonId,
            },
        });
    }

    // noinspection JSUnusedGlobalSymbols
    public getByTopicId(topicId: string) {
        return axios.get<Lesson[]>('/lessons/getByTopicId', {
            params: {
                topicId,
            },
        });
    }

    public count() {
        return axios.get<number>('/lessons/count');
    }

    public countPersonal() {
        return axios.get<number>('/lessons/countPersonal');
    }

    // tslint:disable-next-line:max-line-length
    public store(
        lesson: Lesson,
        tradeId: number,
        topicId: number,
        phases: Phase[],
        tags: Tag[],
        userId: number | null = null,
        projectId = 0,
        parentLesson: Lesson | null = null
    ) {
        const parentId = parentLesson ? parentLesson.id : null;
        return axios.post('/lessons/store', {
            insight: lesson.insight,
            more_info: lesson.more_info,
            tradeId,
            topicId,
            phases: phases.map((phase) => phase.id),
            tags: tags.map((tag) => tag.id),
            mandatory: lesson.mandatory,
            userId,
            projectId,
            parentId,
        });
    }

    public storeApproved(lesson: Lesson, approved: boolean) {
        return axios.post('/lessons/storeApproved', {
            lessonId: lesson.id,
            approved,
        });
    }

    public update(
        lesson: Lesson,
        phases: Phase[],
        topic: Topic,
        tags: Tag[],
        projectId = 0,
        parentLesson: Lesson | null
    ) {
        const parentId = parentLesson ? parentLesson.id : null;
        return axios.post('/lessons/update', {
            id: lesson.id,
            insight: lesson.insight,
            more_info: lesson.more_info,
            phases: phases.map((phase) => phase.id),
            trades: lesson.trades.map((trade) => trade.id),
            tags: tags.map((tag) => tag.id),
            topicId: topic.id,
            mandatory: lesson.mandatory,
            projectId,
            parentId,
        });
    }

    // noinspection JSUnusedGlobalSymbols
    public updateOrder(lesson: Lesson, direction: string = 'up') {
        return axios.post('/lessons/update/order', {
            id: lesson.id,
            direction,
        });
    }

    public remove(lesson: Lesson) {
        return axios.post('/lessons/remove', {
            id: lesson.id,
        });
    }
}

export const lessonWebservice = new LessonWebservice();
